// extracted by mini-css-extract-plugin
module.exports = {"container":"IconToggler__container___an-ME","transformed":"IconToggler__transformed___2WCA0","icon":"IconToggler__icon___1J2kh"};